"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// NOTE: Be sure to update the int/string mappings below when editing this enum
var MediaType;
(function (MediaType) {
    MediaType["Audio"] = "AUDIO";
    MediaType["Video"] = "VIDEO";
    MediaType["SupportingInfo"] = "SUPPORTING_INFO";
})(MediaType = exports.MediaType || (exports.MediaType = {}));
exports.MediaTypeStringIntMap = new Map([
    [MediaType.Audio, 1],
    [MediaType.Video, 2],
    [MediaType.SupportingInfo, 3],
]);
exports.MediaTypeIntStringMap = new Map([
    [1, MediaType.Audio],
    [2, MediaType.Video],
    [3, MediaType.SupportingInfo],
]);
//# sourceMappingURL=mediaType.js.map